import React, { Component } from 'react';
import './App.css';

class Timeline extends Component {
  constructor(){
    super();
    this.birthDate = new Date(1989,6,14).getTime();
    this.toDay = Date.now();
    this.ageTime = new Date((this.toDay) - (this.birthDate));
    this.age = (Math.floor(this.ageTime.getFullYear() - 1970));
    // this.age = Math.round(((new Date() - new Date(1989, 6, 14)) / (1000 * 60 * 60 * 24))/365);

  }
  render(){
    return(
      <section>
        <div className="timeline">
        <div className="container">
          <h3 className="white-text">PROFILE</h3>
          <section className="card">
            <h3>Full Name</h3>
            <p className="content">Murali Kannan M Y</p>
          </section>
          <section className="card">
            <h3>Date of Birth</h3>
            <p className="content">14 July 1989 ({this.age} years old)</p>
          </section>
          <section className="card">
            <h3>Education</h3>
            <p className="content">BE Computer Science & Engineering,</p>
            <p className="content">Hindustan College of Engineering, Chennai (under Anna University)</p>
          </section>
          <section className="card">
            <h3>Profession</h3>
            <p className="subTitle">Present</p>
            <p className="content">Independent Software Developer (FULL STACK ENGINEER) <a className="btn"  rel="noopener noreferrer" href="https://muralikannan.com" target="_blank"><i className="fas fa-external-link-alt"></i> website</a> </p>
            <p className="subTitle">Associated with</p>
            <p className="content">Digibizdev - Technology partner</p>
            <p className="subTitle">Past</p>
            <p className="content">SalesboxCRM - Senior User Experience Developer</p>
          </section>
          <section className="card">
            <h3 className="title">Family</h3>
            <p className="content">
              <span className="subTitleBold">Father</span><br/>
              M Yogaraj M.A,CAIIB<br/>
              <span className="subTitleBold">Senior Manager PNB (retd)</span>
            </p>
            <p className="content">
                <span className="subTitleBold">Mother</span><br/>
              R B Mano Rani  M.A,B.Ed
            </p>
            <p className="subTitle">Siblings - None</p>
            <a href="tel:+919940143957" className="btn"> Call</a>
          </section>
          <section className="card">
            <h3>Permanent Residence</h3>
            <p className="content">59,G2,2nd Lane, City Park,Egatoor - ch - 603103</p>
          </section>
          <p className="white-text">mail@muralikannan.com</p>
        </div>
        </div>
      </section>
    )
  }
}
// <section className="card">
//   <h3>Hobby</h3>
//   <p className="content">Photography <a href="https://facebook.com/muralikannanphotography"><i class="fab fa-2x fa-facebook-square"></i></a></p>
//   <p className="content">Graphic Design</p>
//   <p className="content">Learning new programming languages</p>
//   <p className="content">Motion Graphics & Color Grading</p>
//   <p className="content">Comic Writing</p>
// </section>

export default Timeline;



// WEBPACK FOOTER //
// ./src/timeline.jsx